export const sidebarIcons = [
    'abacus',
    'analytics-02',
    'bar-code-02-stroke-rounded',
    'calendar-01',
    'chart-bar-line',
    'coins-01',
    'container-truck',
    'coupon-01',
    'dashboard-circle',
    'dashboard-speed-01',
    'entering-geo-fence',
    'fuel-station',
    'gateway',
    'help-square',
    'invoice',
    'joker',
    'maps-search',
    'settings-02-stroke-rounded',
    'setting-04',
    'shopify',
    'store-01',
    'student-card',
    'store-location-02',
    'ticket-03',
    'user-circle',
    'user-square',
    'user-group',
    // #
    'add-money-circle',
    'invoice-03',
    'new-office',
    'plate',
    'affiliate',
    'file-management',
    'discount-tag-02',
    'chart-histogram',
    'tow-truck',
    'geometric-shapes-01',
    'binary-code',
    'mail-open',
    'product-loading',
];
